import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageConfigService } from '../language-config.service';
import { warrantyOptionsModel } from '@app/core/components/help-options/help-options-model';
import { SeoService } from '@app/core/services/seo.service';
import { OgService } from '@app/core/services/og.service';

@Component({
    selector: 'app-warranty',
    templateUrl: './warranty.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./warranty.component.scss']
})
export class WarrantyComponent {
    public warrantyOptionsModelCard: Array<any> = warrantyOptionsModel;
    public notRedirect: boolean = false;

    public constructor(
        private seoService: SeoService,
        private ogService: OgService,
        private activatedRoute: ActivatedRoute,
        private languageConfigService: LanguageConfigService,
        private router: Router
    ) {
        this.languageConfigService
            .setActivatedRoute(this.activatedRoute)
            .updateLanguageFromUrl('warranty')
            .subscribe(() => {
                this.seoService.addTitle('Garantía | Saldoar');
                this.seoService.addCanonical('wiki/warranty');
                this.ogService.addOpenGraphMetadata({ url: 'wiki/warranty' });
                this.seoService.addMetaName('keywords', 'garantía, saldo, seguridad, cotizacion, estafas');
                this.seoService.addMetaName('description', 'Tranquilo, nuestra garantía te protege.');
            });
    }

    public goToDefinition(): void {
        let routeRedirect: string = '/por-que-elegir-saldoar';
        this.router.navigate([routeRedirect]);
    }
}
